// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8Xlbk","label":"styles_label__XWch-"};